import React, { Component } from 'react';
import { Button, Modal, Row, Col, FormGroup, FormControl, Alert } from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid';
import { withTranslation} from 'react-i18next';

class CognitoNewPasswordModal extends Component {

    constructor(prop) {
        super(prop);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
            isNotSame: false,
        };
    }

    handleClose() {

        // リセット
        this.setState({
            isNotSame: false,
        })

        // 入力されたパスワードを取得
        let pass1 = this.inputPassword1.value;
        let pass2 = this.inputPassword2.value;

        // パスワード再入力値が同じ値か
        if (pass1 !== pass2) {
            this.setState({
                isNotSame: true,
            })
            return;
        }

        this.props.registerNewPassword(pass1);

    }

    render() {
        const {t} = this.props;
        const Error = () => (
            <div>
                {(() => {
                    return (
                        <Row>
                            <Col xsOffset={1} xs={10}>
                                <Alert bsStyle="danger"><p>{t('NewPassWord.DoNotMatch')}Passwords do not match.</p></Alert>
                            </Col>
                        </Row>
                    );
                })()}
            </div>
        );

        return (
            <div>
                <Modal show={true}>
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon size='1x' icon={faExclamationCircle} />{t('NewPassWord.RegistrationPassword')}
                         </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup controlId="formHorizontalPassword2">
                            <Row>
                                <Col xsOffset={1} xs={10}>
                                    <h4>{t('NewPassWord.EnterNewPass')}
                                    </h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col xsOffset={1} xs={10}>
                                    <FormControl type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword1 = ref }} />
                                </Col>
                            </Row>
                            <Row>
                                <Col xsOffset={1} xs={10}>
                                    <h4>{t('NewPassWord.EnterNewPassAgain')}
                                    </h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col xsOffset={1} xs={10}>
                                    <FormControl type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword2 = ref }} />
                                </Col>
                            </Row>
                            <div className='mini-div' />
                            {
                                this.state.isNotSame ?
                                    <Error /> :
                                    false
                            }
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>OK</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withTranslation()(CognitoNewPasswordModal);



// WEBPACK FOOTER //
// ./src/js/CognitoNewPasswordModal.js